import { useState, useEffect } from "react";
import { GigyaGroupModels } from "../types/gigya.schema";

type NicknameState = {
  nickname?: string;
  groupId?: string;
};

export const useSetGroupMemberInfo = () => {
  const [groupMemberInfo, setGroupMemberInfo] = useState({
    role: "",
    status: "",
    permissions: "",
    nickname: "",
    comment: "",
  });
  const [loadinggroupMemberNickname, setLoadingGroupMemberNickname] =
    useState(true);
  const [groupMemberNicknameError, setGroupMemberNicknameError] =
    useState(false);
  const [groupMemberNickname, setGroupMemberNickname] = useState<NicknameState>(
    {},
  );
  const [groupMemberInfoResp, setGroupMemberInfoResp] = useState({
    success: false,
  });

  useEffect(() => {
    if (groupMemberNickname.nickname) {
      window.gigya.accounts.groups.setGroupMemberInfo({
        model: GigyaGroupModels.ClinicModel,
        groupId: groupMemberNickname.groupId || "",
        relationshipData: { nickname: groupMemberNickname.nickname },
        callback: (resp) => {
          if (resp.errorCode) {
            // HANDLE ERROR HERE
            console.log("Error Details: ", resp.errorDetails);
            setGroupMemberInfoResp({ success: false });
            setLoadingGroupMemberNickname(true);
            setGroupMemberNicknameError(true);
          } else {
            setGroupMemberInfoResp({ success: true });
            setLoadingGroupMemberNickname(false);
            setGroupMemberNicknameError(false);
          }
        },
      });
    }

    return () => {
      setGroupMemberInfoResp({ success: false });
      setGroupMemberInfo({
        role: "",
        status: "",
        permissions: "",
        nickname: "",
        comment: "",
      });
      setGroupMemberNickname({});
    };
  }, [groupMemberNickname.nickname, groupMemberNickname.groupId]);

  return {
    setGroupMemberInfo,
    setGroupMemberNickname,
    groupMemberInfoResp,
    loadinggroupMemberNickname,
    groupMemberNicknameError,
  };
};
